import api from '../../api';
import { push } from 'connected-react-router';
import { store as storeNotification } from 'react-notifications-component';
import { socket } from './../store/socket';

const notificationConfig = {
  container: 'top-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: 1500,
    showIcon: true
  }
};

export const suppliersStartRequest = () => {
  return {
    type: 'SUPPLIERS_START_REQUEST'
  };
};

export const suppliersEndRequest = () => {
  return {
    type: 'SUPPLIERS_END_REQUEST'
  };
};

export const getAllSuppliersSuccess = ({ data }) => {
  return {
    type: 'SUPPLIERS_GET_ALL_SUCCESS',
    payload: data
  };
};

export const getAllSuppliersError = error => {
  return {
    type: 'SUPPLIERS_GET_ALL_ERROR',
    payload: error
  };
};

export const addSuppliersSuccess = ({ data }) => {
  return {
    type: 'SUPPLIERS_ADD_SUCCESS',
    payload: data
  };
};

export const addSuppliersError = error => {
  return {
    type: 'SUPPLIERS_ADD_ERROR',
    payload: error
  };
};

export const editSuppliersSuccess = ({ data }) => {
  return {
    type: 'SUPPLIERS_EDIT_SUCCESS',
    payload: data
  };
};

export const editSuppliersError = error => {
  return {
    type: 'SUPPLIERS_EDIT_ERROR',
    payload: error
  };
};

export const removeSuppliersSuccess = id => {
  return {
    type: 'SUPPLIERS_REMOVE_SUCCESS',
    payload: id
  };
};

export const removeSuppliersError = error => {
  return {
    type: 'SUPPLIERS_REMOVE_ERROR',
    payload: error
  };
};

export const suppliersModifyStore = ({ data }) => {
  return {
    type: 'SUPPLIERS_MODIFY_STORE',
    payload: data
  };
};

export const addSuppliers = (data, formReset, submitBtn) => {
  return async dispatch => {
    try {
      submitBtn.disabled = true;
      dispatch(suppliersStartRequest());
      const response = await api().post('/api/suppliers', data);
      dispatch(addSuppliersSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'ADD',
        module: 'suppliers',
        data: [response.data],
        company: response.data.company
      });
      formReset();
    } catch (err) {
      dispatch(addSuppliersError(err));
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      setTimeout(() => {
        dispatch(suppliersEndRequest());
        submitBtn.disabled = false;
      }, 1800);
    }
  };
};

export const getAllSuppliers = (params = {}) => {
  return async dispatch => {
    try {
      dispatch(suppliersStartRequest());
      const response = await api().get('/api/suppliers', { params });
      dispatch(getAllSuppliersSuccess(response));
    } catch (err) {
      dispatch(getAllSuppliersError(err));
    } finally {
      dispatch(suppliersEndRequest());
    }
  };
};

export const editSuppliers = (data, submitBtn = {}, handleModalClose) => {
  return async dispatch => {
    const defaultMsg = button => {
      return new Promise(resolve => {
        document
          .getElementsByClassName('page-content')[0]
          .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setTimeout(() => {
          dispatch(suppliersEndRequest());
          button.disabled = false;
          resolve(true);
        }, 1800);
      });
    };

    try {
      submitBtn.disabled = true;
      dispatch(suppliersStartRequest());
      const id = data._id;
      const response = await api().put('/api/suppliers/' + id, data);
      dispatch(editSuppliersSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'EDIT',
        module: 'suppliers',
        data: [response.data],
        company: response.data.company
      });
      await defaultMsg(submitBtn);
      if (handleModalClose) {
        handleModalClose();
      } else {
        dispatch(push('/suppliers'));
      }
    } catch (err) {
      dispatch(editSuppliersError(err));
      await defaultMsg(submitBtn);
    }
  };
};

export const removeSuppliers = id => {
  return async dispatch => {
    try {
      dispatch(suppliersStartRequest());
      await api().delete('/api/suppliers/' + id);
      dispatch(removeSuppliersSuccess(id));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'REMOVE',
        module: 'suppliers',
        data: id
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Fornecedor removido com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(removeSuppliersError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao remover fornecedor.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(suppliersEndRequest());
    }
  };
};

export const restoreSuppliers = data => {
  return async dispatch => {
    try {
      dispatch(suppliersStartRequest());
      const id = data._id;
      const response = await api().put('/api/suppliers/' + id, data);
      dispatch(editSuppliersSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'RESTORE',
        module: 'suppliers',
        data: [response.data],
        company: response.data.company
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Fornecedor restaurado com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(editSuppliersError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao restaurar fornecedor.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(suppliersEndRequest());
    }
  };
};
